// import React, { useEffect, useState } from "react";
// import { useAuthState } from "react-firebase-hooks/auth";
// import "react-quill/dist/quill.snow.css";
// import auth from "../../firebase.init";
// import Pagination from "../../components/Shared/Pagination";
// import { Link } from "react-router-dom";
// import { Helmet } from "react-helmet";
// import LoadingAnimations from "../../components/Shared/LoadingAnimations";
// import { Search, Calendar, SquarePen, Trash2, Mail } from "lucide-react";
// import AdminProductStatusModal from "./AdminProductStatusModal";
// import DeleteConfirmationModal from "./DeleteConfirmationModal";
// import toast from "react-hot-toast";
// import AdminEmailModal from "./AdminEmailModal";
// import AdminFeatureStatus from "./AdminFeatureStatus";
// import { useSecureFetch } from "../../hooks/useSecureFetch";

// const AdminAllProducts = () => {
//   const { secureFetch } = useSecureFetch();
//   const [products, setProducts] = useState([]);
//   const [user] = useAuthState(auth);
//   const [categories, setCategories] = useState([]);
//   const [orders, setOrders] = useState([]);
//   const [showStatusModal, setShowStatusModal] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [users, setUsers] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [productToDelete, setProductToDelete] = useState(null);
//   const [isDeleting, setIsDeleting] = useState(false);
//   const [showEmailModal, setShowEmailModal] = useState(false);
//   const [selectedSeller, setSelectedSeller] = useState(null);
//   const [homePageFeature, setHomePageFeature] = useState("");
//   const [categoryFeature, setCategoryFeature] = useState("");

//   // Function to open delete modal
//   const handleDeleteClick = (product) => {
//     setProductToDelete(product);
//     setShowDeleteModal(true);
//   };

//   const handleEmailClick = (product, seller) => {
//     setSelectedSeller(seller);
//     setSelectedProduct(product);
//     setShowEmailModal(true);
//   };

//   // Filter states
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [sellerSearchTerm, setSellerSearchTerm] = useState("");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState("");

//   // Fetch products
//   useEffect(() => {
//     fetch(`https://server.enjoywiki.com/flip-server/products`)
//       .then((res) => res.json())
//       .then((info) => setProducts(info.reverse()));
//   }, [user?.email]);

//   // Fetch categories
//   useEffect(() => {
//     fetch(`https://server.enjoywiki.com/flip-server/categories`)
//       .then((res) => res.json())
//       .then((info) => setCategories(info.reverse()));
//   }, [user]);

//   // Fetch orders
//   useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const data = await secureFetch("https://server.enjoywiki.com/flip-server/orders");
//         setOrders(data);
//       } catch (error) {
//         console.error("Error fetching orders:", error);
//       }
//     };

//     fetchOrders();
//   }, [secureFetch]);

//   // Fetch users
//   useEffect(() => {
//     const fetchUsers = async () => {
//       try {
//         const users = await secureFetch(`https://server.enjoywiki.com/flip-server/users`);
//         setUsers(users);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchUsers();
//   }, [secureFetch]);

//   // Update the filteredProducts function to include the new filters
//   const filteredProducts = products.filter((product) => {
//     const matchesSearch = product.productName
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase());
//     const matchesCategory =
//       !selectedCategory || product.category === selectedCategory;
//     const matchesStatus =
//       !selectedStatus || product.productStatus === selectedStatus;
//     const matchesHomeFeature =
//       !homePageFeature || product.homePageFeature === homePageFeature;
//     const matchesCategoryFeature =
//       !categoryFeature || product.categoryFeature === categoryFeature;

//     const seller = users.find(
//       (user) => user.UserEmail === (product.UserEmail || product.sellerEmail)
//     );
//     const matchesSeller =
//       !sellerSearchTerm ||
//       (seller &&
//         (seller.userName
//           ?.toLowerCase()
//           .includes(sellerSearchTerm.toLowerCase()) ||
//           seller.UserEmail?.toLowerCase().includes(
//             sellerSearchTerm.toLowerCase()
//           )));

//     const productDate = new Date(product.createdAt);
//     const start = startDate ? new Date(startDate) : null;
//     const end = endDate ? new Date(endDate) : null;
//     const matchesDateRange =
//       (!start || productDate >= start) && (!end || productDate <= end);

//     return (
//       matchesSearch &&
//       matchesCategory &&
//       matchesSeller &&
//       matchesDateRange &&
//       matchesStatus &&
//       matchesHomeFeature &&
//       matchesCategoryFeature
//     );
//   });

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentService = filteredProducts.slice(
//     indexOfFirstItem,
//     indexOfLastItem
//   );

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };

//   // Status change handlers
//   const handleStatusChangeModal = (product) => {
//     setSelectedProduct(product);
//     setShowStatusModal(true);
//   };

//   const handleProductStatusUpdate = (newStatus) => {
//     const updatedProducts = products.map((product) =>
//       product._id === selectedProduct._id
//         ? { ...product, productStatus: newStatus }
//         : product
//     );
//     setProducts(updatedProducts);
//   };

//   const formatDate = (isoString) => {
//     const date = new Date(isoString);
//     return date.toLocaleDateString("en-US", {
//       month: "long",
//       day: "numeric",
//       year: "numeric",
//     });
//   };

//   const handleDeleteProduct = async () => {
//     if (!productToDelete) return;

//     setIsDeleting(true);
//     try {
//       const response = await fetch(
//         `https://server.enjoywiki.com/flip-server/delete-product/${productToDelete._id}`,
//         {
//           method: "DELETE",
//         }
//       );

//       const data = await response.json();

//       if (response.ok) {
//         // Remove the deleted product from the state
//         setProducts(
//           products.filter((product) => product._id !== productToDelete._id)
//         );
//         setShowDeleteModal(false);
//         toast("Product deleted successfully");
//       } else {
//         alert(data.message || "Failed to delete product");
//       }
//     } catch (error) {
//       console.error("Error deleting product:", error);
//       alert("An error occurred while deleting the product");
//     } finally {
//       setIsDeleting(false);
//       setProductToDelete(null);
//     }
//   };

//   return (
//     <main className="dashboard-main min-vh-100">
//       <div className="d-flex flex-column gap-4 pb-110 p-4">
//         <Helmet>
//           <title>
//             All Products Listings | FlipBundle - Manage Your Digital Product
//             Listings
//           </title>
//           <meta
//             name="description"
//             content="View and manage your digital product listings on FlipBundle. Easily update, promote, and track your products for increased sales."
//           />
//         </Helmet>

//         <div className="d-flex justify-content-between align-items-center">
//           <div>
//             <h3 className="text-24 fw-bold text-dark-300 mb-2">
//               Products List
//             </h3>
//             <ul className="d-flex align-items-center gap-2">
//               <li className="text-dark-200 fs-6">Admin Dashboard</li>
//               <li>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width={5}
//                   height={11}
//                   viewBox="0 0 5 11"
//                   fill="none"
//                 >
//                   <path
//                     d="M1 10L4 5.5L1 1"
//                     stroke="#5B5B5B"
//                     strokeWidth="1.2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </li>
//               <li className="text-lime-300 fs-6">Products</li>
//             </ul>
//           </div>
//         </div>

//         {/* Filter Section */}
//         <div className="card p-4 mb-4">
//           <div className="row g-3">
//             <div className="col-md-2">
//               <select
//                 className="form-select"
//                 value={selectedStatus}
//                 onChange={(e) => setSelectedStatus(e.target.value)}
//               >
//                 <option value="">All Status</option>
//                 <option value="Pending">Pending</option>
//                 <option value="Draft">Draft</option>
//                 <option value="Published">Published</option>
//                 <option value="Rejected">Rejected</option>
//               </select>
//             </div>
//             <div className="col-md-3">
//               <div className="input-group">
//                 <span className="input-group-text">
//                   <Search size={18} />
//                 </span>
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Search products name..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//               </div>
//             </div>

//             <div className="col-md-2">
//               <select
//                 className="form-select"
//                 value={selectedCategory}
//                 onChange={(e) => setSelectedCategory(e.target.value)}
//               >
//                 <option value="">All Categories</option>
//                 {categories.map((category) => (
//                   <option key={category._id} value={category.categoryName}>
//                     {category.categoryName}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="col-md-2">
//               <div className="input-group">
//                 <span className="input-group-text">
//                   <Search size={18} />
//                 </span>
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Search seller..."
//                   value={sellerSearchTerm}
//                   onChange={(e) => setSellerSearchTerm(e.target.value)}
//                 />
//               </div>
//             </div>

//             <div className="col-md-3">
//               <div className="input-group">
//                 <span className="input-group-text">
//                   <Calendar size={18} />
//                 </span>
//                 <input
//                   type="date"
//                   className="form-control"
//                   value={startDate}
//                   onChange={(e) => setStartDate(e.target.value)}
//                 />
//                 <input
//                   type="date"
//                   className="form-control"
//                   value={endDate}
//                   onChange={(e) => setEndDate(e.target.value)}
//                 />
//               </div>
//             </div>
//             <div className="col-md-2">
//               <label
//                 htmlFor="homePageFeature"
//                 className="form-label text-dark-200 mb-0"
//               >
//                 Homepage Feature
//               </label>
//               <select
//                 id="homePageFeature"
//                 className="form-select px-3 py-2 border rounded-2"
//                 value={homePageFeature}
//                 onChange={(e) => setHomePageFeature(e.target.value)}
//                 style={{ minWidth: "180px" }}
//               >
//                 <option value="">All Homepage Features</option>
//                 <option value="Yes">Featured</option>
//                 <option value="No">Not Featured</option>
//               </select>
//             </div>

//             <div className="col-md-2">
//               <label
//                 htmlFor="homePageFeature"
//                 className="form-label text-dark-200 mb-0"
//               >
//                 Category Feature
//               </label>
//               <select
//                 id="categoryFeature"
//                 className="form-select px-3 py-2 border rounded-2"
//                 value={categoryFeature}
//                 onChange={(e) => setCategoryFeature(e.target.value)}
//                 style={{ minWidth: "180px" }}
//               >
//                 <option value="">All Category Features</option>
//                 <option value="Yes">Featured</option>
//                 <option value="No">Not Featured</option>
//               </select>
//             </div>
//           </div>
//         </div>

//         {/* Content */}
//         <div className="gig-info-card">
//           <div className="gig-info-body">
//             <div className="overflow-x-auto">
//               <div className="w-100">
//                 <table className="w-100 dashboard-table">
//                   <thead>
//                     <tr>
//                       <th scope="col" className="ps-4">
//                         Product Name
//                       </th>
//                       <th scope="col" className="ps-4">
//                         Seller Info
//                       </th>
//                       <th scope="col">Sales</th>
//                       <th scope="col">View</th>
//                       <th scope="col">Price</th>
//                       <th scope="col" className="text-center">
//                         Actions
//                       </th>
//                       <th scope="col" className="text-center">
//                         Edit
//                       </th>
//                       <th scope="col" className="text-center">
//                         Delete
//                       </th>
//                       <th scope="col" className="text-center">
//                         Email
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {products === null ? (
//                       <tr>
//                         <td colSpan="7" className="text-center p-4">
//                           <LoadingAnimations
//                             type="pulse"
//                             color="#2563eb"
//                             size="md"
//                           />
//                         </td>
//                       </tr>
//                     ) : currentService.length === 0 ? (
//                       <tr>
//                         <td colSpan="9" className="text-center p-4">
//                           No Products Found!
//                         </td>
//                       </tr>
//                     ) : (
//                       currentService.map((product) => (
//                         <tr key={product._id}>
//                           <td>
//                             <div className="d-flex gap-3 align-items-center project-name">
//                               <div className="order-img">
//                                 {product.featuredImage && (
//                                   <img
//                                     src={product.featuredImage}
//                                     alt={product.productName}
//                                     style={{
//                                       width: "50px",
//                                       height: "50px",
//                                       objectFit: "cover",
//                                       borderRadius: "8px",
//                                     }}
//                                   />
//                                 )}
//                               </div>
//                               <div>
//                                 <a
//                                   href={`/${product.slug}/${product.productId}`}
//                                   target="_blank"
//                                   rel="noreferrer"
//                                   className="project-link"
//                                 >
//                                   {product.productName}
//                                 </a>
//                                 <ul className="d-flex gap-1 order-category mt-1">
//                                   {product.createdAt && (
//                                     <li className="text-dark-200">
//                                       Added On - {formatDate(product.createdAt)}
//                                     </li>
//                                   )}
//                                 </ul>
//                                 <ul className="d-flex gap-1 order-category mt-1">
//                                   <li className="text-dark-200">
//                                     Category: {product.category}
//                                   </li>
//                                 </ul>
//                                 <ul className="d-flex gap-1 order-category mt-2">
//                                   {/* homePageFeature and  categoryFeature option */}
//                                   <AdminFeatureStatus product={product} />
//                                 </ul>
//                               </div>
//                             </div>
//                           </td>
//                           <td>
//                             {isLoading ? (
//                               <LoadingAnimations
//                                 type="pulse"
//                                 color="#2563eb"
//                                 size="sm"
//                               />
//                             ) : (
//                               <div className="d-flex gap-3 align-items-center">
//                                 {(() => {
//                                   const seller = users.find(
//                                     (user) =>
//                                       user.UserEmail ===
//                                       (product.UserEmail || product.sellerEmail)
//                                   );
//                                   return (
//                                     <>
//                                       <div className="order-img">
//                                         {seller?.profileURL && (
//                                           <img
//                                             src={seller.profileURL}
//                                             alt={seller.userName}
//                                             style={{
//                                               width: "50px",
//                                               height: "50px",
//                                               objectFit: "cover",
//                                               borderRadius: "8px",
//                                             }}
//                                           />
//                                         )}
//                                       </div>
//                                       <div>
//                                         <Link
//                                           to={`/profile-seller/${seller?._id}`}
//                                         >
//                                           <h6 className="mb-1">
//                                             {seller?.userName || "N/A"}
//                                           </h6>
//                                         </Link>
//                                         <p className="text-dark-200 mb-0">
//                                           {seller?.UserEmail || "N/A"}
//                                         </p>
//                                       </div>
//                                     </>
//                                   );
//                                 })()}
//                               </div>
//                             )}
//                           </td>
//                           <td className="text-dark-200">
//                             {
//                               orders.filter(
//                                 (order) =>
//                                   order.packageId === product._id &&
//                                   order.paymentStatus === "Paid"
//                               ).length
//                             }
//                           </td>
//                           <td className="text-dark-200">
//                             <p>
//                               {product.viewCount > 0
//                                 ? `${product.viewCount} views`
//                                 : "No view"}
//                             </p>
//                           </td>
//                           <td className="text-dark-200">
//                             ${product.price} USD
//                           </td>

//                           <td className="text-center">
//                             <button
//                               className={`btn btn-sm ${
//                                 product.productStatus === "Draft"
//                                   ? "btn-warning"
//                                   : product.productStatus === "Published"
//                                   ? "btn-info"
//                                   : product.productStatus === "Approved"
//                                   ? "btn-success"
//                                   : "btn-secondary"
//                               }`}
//                               onClick={() => handleStatusChangeModal(product)}
//                             >
//                               {product.productStatus}
//                             </button>
//                           </td>
//                           <td className="text-center">
//                             <Link
//                               to={`/admin/edit-product/${product._id}`}
//                               className="btn btn-primary btn-sm"
//                             >
//                               <SquarePen size={15} /> Edit
//                             </Link>
//                           </td>
//                           <td className="text-center">
//                             <button
//                               className="btn btn-danger btn-sm"
//                               onClick={() => handleDeleteClick(product)}
//                             >
//                               <Trash2 size={15} /> Delete
//                             </button>
//                           </td>
//                           <DeleteConfirmationModal
//                             show={showDeleteModal}
//                             handleClose={() => {
//                               setShowDeleteModal(false);
//                               setProductToDelete(null);
//                             }}
//                             handleConfirm={handleDeleteProduct}
//                             isDeleting={isDeleting}
//                             productName={productToDelete?.productName}
//                           />
//                           {/*Open modal and email sent option */}
//                           <td className="text-center">
//                             <button
//                               className="btn btn-primary btn-sm"
//                               onClick={() => {
//                                 const seller = users.find(
//                                   (user) =>
//                                     user.UserEmail ===
//                                     (product.UserEmail || product.sellerEmail)
//                                 );
//                                 handleEmailClick(product, seller); // Make sure to pass both product and seller
//                               }}
//                             >
//                               <Mail size={15} /> Message
//                             </button>
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                   <AdminEmailModal
//                     show={showEmailModal}
//                     handleClose={() => {
//                       setShowEmailModal(false);
//                       setSelectedSeller(null);
//                     }}
//                     recipientEmail={selectedSeller?.UserEmail}
//                     recipientName={selectedSeller?.userName}
//                     productName={selectedProduct?.productName}
//                     customProductId={selectedProduct?.productId}
//                   />
//                 </table>
//               </div>
//             </div>

//             <AdminProductStatusModal
//               show={showStatusModal}
//               handleClose={() => setShowStatusModal(false)}
//               productId={selectedProduct?._id}
//               customProductId={selectedProduct?.productId}
//               productName={selectedProduct?.productName}
//               currentStatus={selectedProduct?.productStatus}
//               rejection={selectedProduct?.rejectionReason}
//               onStatusUpdate={handleProductStatusUpdate}
//               sellerEmail={selectedProduct?.sellerEmail}
//             />
//             {/* Results Summary */}
//             <div className="d-flex justify-content-between align-items-center mt-4 mb-3">
//               <div className="text-dark-200">
//                 Showing {indexOfFirstItem + 1} to{" "}
//                 {Math.min(indexOfLastItem, filteredProducts.length)} of{" "}
//                 {filteredProducts.length} products
//               </div>
//             </div>
//             {/* Pagination */}
//             {filteredProducts.length > itemsPerPage && (
//               <div className="pagination-container mt-4 d-flex justify-content-center">
//                 <Pagination
//                   currentPage={currentPage}
//                   totalPages={Math.ceil(filteredProducts.length / itemsPerPage)}
//                   onPageChange={handlePageChange}
//                 />
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </main>
//   );
// };

// export default AdminAllProducts;

import React, { useEffect, useState, useCallback } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import "react-quill/dist/quill.snow.css";
import auth from "../../firebase.init";
import Pagination from "../../components/Shared/Pagination";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import LoadingAnimations from "../../components/Shared/LoadingAnimations";
import { Search, Calendar, SquarePen, Trash2, Mail } from "lucide-react";
import AdminProductStatusModal from "./AdminProductStatusModal";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import toast from "react-hot-toast";
import AdminEmailModal from "./AdminEmailModal";
import AdminFeatureStatus from "./AdminFeatureStatus";
import { useSecureFetch } from "../../hooks/useSecureFetch";

const AdminAllProducts = () => {
  const { secureFetch, isLoading: secureFetchLoading, error: secureFetchError } = useSecureFetch();
  const [products, setProducts] = useState([]);
  const [user] = useAuthState(auth);
  const [categories, setCategories] = useState([]);
  const [orders, setOrders] = useState([]);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [users, setUsers] = useState([]);
  // Consolidated loading state from secureFetch for initial data loading
  const [isLoading, setIsLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [homePageFeature, setHomePageFeature] = useState("");
  const [categoryFeature, setCategoryFeature] = useState("");

  // Function to open delete modal
  const handleDeleteClick = (product) => {
    setProductToDelete(product);
    setShowDeleteModal(true);
  };

  const handleEmailClick = (product, seller) => {
    setSelectedSeller(seller);
    setSelectedProduct(product);
    setShowEmailModal(true);
  };

  // Filter states
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [sellerSearchTerm, setSellerSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  // Fetch products using secureFetch
  const fetchProducts = useCallback(async () => {
    setIsLoading(true); // Set local loading for products specifically
    try {
      const data = await secureFetch(`https://server.enjoywiki.com/flip-server/products`);
      if (Array.isArray(data)) {
        setProducts(data.reverse());
      } else {
        console.warn("secureFetch for products did not return an array:", data);
        setProducts([]);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      setProducts([]); // Clear products on error
    } finally {
      setIsLoading(false);
    }
  }, [secureFetch]); // secureFetch is a dependency

  // Fetch categories using secureFetch
  const fetchCategories = useCallback(async () => {
    try {
      const data = await secureFetch(`https://server.enjoywiki.com/flip-server/categories`);
      if (Array.isArray(data)) {
        setCategories(data.reverse());
      } else {
        console.warn("secureFetch for categories did not return an array:", data);
        setCategories([]);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategories([]); // Clear categories on error
    }
  }, [secureFetch]);

  // Fetch orders using secureFetch (already done, but keeping in sync)
  const fetchOrders = useCallback(async () => {
    try {
      const data = await secureFetch("https://server.enjoywiki.com/flip-server/orders");
      if (Array.isArray(data)) {
        setOrders(data);
      } else {
        console.warn("secureFetch for orders did not return an array:", data);
        setOrders([]);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      setOrders([]); // Clear orders on error
    }
  }, [secureFetch]);

  // Fetch users using secureFetch (already done, but keeping in sync)
  const fetchUsers = useCallback(async () => {
    try {
      const usersData = await secureFetch(`https://server.enjoywiki.com/flip-server/users`);
      if (Array.isArray(usersData)) {
        setUsers(usersData);
      } else {
        console.warn("secureFetch for users did not return an array:", usersData);
        setUsers([]);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]); // Clear users on error
    } finally {
      // This isLoading is for the overall data loading for the component
      // We will adjust the logic below to consider all fetch statuses
    }
  }, [secureFetch]);

  // Combined useEffect for initial data fetching
  useEffect(() => {
    const loadAllData = async () => {
      setIsLoading(true); // Start overall loading
      // Run all fetches concurrently
      await Promise.all([
        fetchProducts(),
        fetchCategories(),
        fetchOrders(),
        fetchUsers()
      ]);
      setIsLoading(false); // End overall loading after all are done
    };
    if (user?.email) { // Only fetch if user email is available
        loadAllData();
    }
  }, [user?.email, fetchProducts, fetchCategories, fetchOrders, fetchUsers]);


  // Update the filteredProducts function to include the new filters
  const filteredProducts = products.filter((product) => {
    const matchesSearch = product.productName
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesCategory =
      !selectedCategory || product.category === selectedCategory;
    const matchesStatus =
      !selectedStatus || product.productStatus === selectedStatus;
    const matchesHomeFeature =
      !homePageFeature || product.homePageFeature === homePageFeature;
    const matchesCategoryFeature =
      !categoryFeature || product.categoryFeature === categoryFeature;

    const seller = users.find(
      (u) => u.UserEmail === (product.UserEmail || product.sellerEmail)
    );
    const matchesSeller =
      !sellerSearchTerm ||
      (seller &&
        (seller.userName
          ?.toLowerCase()
          .includes(sellerSearchTerm.toLowerCase()) ||
          seller.UserEmail?.toLowerCase().includes(
            sellerSearchTerm.toLowerCase()
          )));

    const productDate = new Date(product.createdAt);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;
    const matchesDateRange =
      (!start || productDate >= start) && (!end || productDate <= end);

    return (
      matchesSearch &&
      matchesCategory &&
      matchesSeller &&
      matchesDateRange &&
      matchesStatus &&
      matchesHomeFeature &&
      matchesCategoryFeature
    );
  });

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentService = filteredProducts.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Status change handlers
  const handleStatusChangeModal = (product) => {
    setSelectedProduct(product);
    setShowStatusModal(true);
  };

  const handleProductStatusUpdate = (newStatus) => {
    const updatedProducts = products.map((product) =>
      product._id === selectedProduct._id
        ? { ...product, productStatus: newStatus }
        : product
    );
    setProducts(updatedProducts);
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  const handleDeleteProduct = async () => {
    if (!productToDelete) return;

    setIsDeleting(true);
    try {
      // Use secureFetch for DELETE request if your backend supports it
      // secureFetch automatically handles headers, but for DELETE, you might need to pass method
      const data = await secureFetch(
        `https://server.enjoywiki.com/flip-server/delete-product/${productToDelete._id}`,
        {
          method: "DELETE",
        }
      );

      // Assuming secureFetch throws an error for !response.ok,
      // so successful deletion means data is returned (or no error thrown).
      // Check for success property if secureFetch returns a response object with it.
      if (data && data.acknowledged) { // Example: assuming backend sends { acknowledged: true }
        // Remove the deleted product from the state
        setProducts(
          products.filter((product) => product._id !== productToDelete._id)
        );
        setShowDeleteModal(false);
        toast("Product deleted successfully");
      } else {
        // If secureFetch doesn't throw on non-ok but returns data, check for specific error messages
        toast.error(data.message || "Failed to delete product");
      }
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error(error.message || "An error occurred while deleting the product");
    } finally {
      setIsDeleting(false);
      setProductToDelete(null);
    }
  };

  // Determine overall loading and error status
  const overallLoading = isLoading || secureFetchLoading;
  const overallError = secureFetchError;

  return (
    <main className="dashboard-main min-vh-100">
      <div className="d-flex flex-column gap-4 pb-110 p-4">
        <Helmet>
          <title>
            All Products Listings | FlipBundle - Manage Your Digital Product
            Listings
          </title>
          <meta
            name="description"
            content="View and manage your digital product listings on FlipBundle. Easily update, promote, and track your products for increased sales."
          />
        </Helmet>

        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h3 className="text-24 fw-bold text-dark-300 mb-2">
              Products List
            </h3>
            <ul className="d-flex align-items-center gap-2">
              <li className="text-dark-200 fs-6">Admin Dashboard</li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={5}
                  height={11}
                  viewBox="0 0 5 11"
                  fill="none"
                >
                  <path
                    d="M1 10L4 5.5L1 1"
                    stroke="#5B5B5B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </li>
              <li className="text-lime-300 fs-6">Products</li>
            </ul>
          </div>
        </div>

        {/* Filter Section */}
        <div className="card p-4 mb-4">
          <div className="row g-3">
            <div className="col-md-2">
              <select
                className="form-select"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="">All Status</option>
                <option value="Pending">Pending</option>
                <option value="Draft">Draft</option>
                <option value="Published">Published</option>
                <option value="Rejected">Rejected</option>
              </select>
            </div>
            <div className="col-md-3">
              <div className="input-group">
                <span className="input-group-text">
                  <Search size={18} />
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search products name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-2">
              <select
                className="form-select"
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                <option value="">All Categories</option>
                {categories.map((category) => (
                  <option key={category._id} value={category.categoryName}>
                    {category.categoryName}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-2">
              <div className="input-group">
                <span className="input-group-text">
                  <Search size={18} />
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search seller..."
                  value={sellerSearchTerm}
                  onChange={(e) => setSellerSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="input-group">
                <span className="input-group-text">
                  <Calendar size={18} />
                </span>
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-2">
              <label
                htmlFor="homePageFeature"
                className="form-label text-dark-200 mb-0"
              >
                Homepage Feature
              </label>
              <select
                id="homePageFeature"
                className="form-select px-3 py-2 border rounded-2"
                value={homePageFeature}
                onChange={(e) => setHomePageFeature(e.target.value)}
                style={{ minWidth: "180px" }}
              >
                <option value="">All Homepage Features</option>
                <option value="Yes">Featured</option>
                <option value="No">Not Featured</option>
              </select>
            </div>

            <div className="col-md-2">
              <label
                htmlFor="homePageFeature"
                className="form-label text-dark-200 mb-0"
              >
                Category Feature
              </label>
              <select
                id="categoryFeature"
                className="form-select px-3 py-2 border rounded-2"
                value={categoryFeature}
                onChange={(e) => setCategoryFeature(e.target.value)}
                style={{ minWidth: "180px" }}
              >
                <option value="">All Category Features</option>
                <option value="Yes">Featured</option>
                <option value="No">Not Featured</option>
              </select>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="gig-info-card">
          <div className="gig-info-body">
            <div className="overflow-x-auto">
              <div className="w-100">
                <table className="w-100 dashboard-table">
                  <thead>
                    <tr>
                      <th scope="col" className="ps-4">
                        Product Name
                      </th>
                      <th scope="col" className="ps-4">
                        Seller Info
                      </th>
                      <th scope="col">Sales</th>
                      <th scope="col">View</th>
                      <th scope="col">Price</th>
                      <th scope="col" className="text-center">
                        Actions
                      </th>
                      <th scope="col" className="text-center">
                        Edit
                      </th>
                      <th scope="col" className="text-center">
                        Delete
                      </th>
                      <th scope="col" className="text-center">
                        Email
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {overallLoading ? (
                      <tr>
                        <td colSpan="9" className="text-center p-4">
                          <LoadingAnimations
                            type="pulse"
                            color="#2563eb"
                            size="md"
                          />
                        </td>
                      </tr>
                    ) : overallError ? (
                      <tr>
                        <td colSpan="9" className="text-center p-4 text-danger">
                          Error: {overallError.message || "Failed to load data."}
                        </td>
                      </tr>
                    ) : currentService.length === 0 ? (
                      <tr>
                        <td colSpan="9" className="text-center p-4">
                          No Products Found!
                        </td>
                      </tr>
                    ) : (
                      currentService.map((product) => (
                        <tr key={product._id}>
                          <td>
                            <div className="d-flex gap-3 align-items-center project-name">
                              <div className="order-img">
                                {product.featuredImage && (
                                  <img
                                    src={product.featuredImage}
                                    alt={product.productName}
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      objectFit: "cover",
                                      borderRadius: "8px",
                                    }}
                                  />
                                )}
                              </div>
                              <div>
                                <a
                                  href={`/${product.slug}/${product.productId}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="project-link"
                                >
                                  {product.productName}
                                </a>
                                <ul className="d-flex gap-1 order-category mt-1">
                                  {product.createdAt && (
                                    <li className="text-dark-200">
                                      Added On - {formatDate(product.createdAt)}
                                    </li>
                                  )}
                                </ul>
                                <ul className="d-flex gap-1 order-category mt-1">
                                  <li className="text-dark-200">
                                    Category: {product.category}
                                  </li>
                                </ul>
                                <ul className="d-flex gap-1 order-category mt-2">
                                  {/* homePageFeature and categoryFeature option */}
                                  <AdminFeatureStatus product={product} />
                                </ul>
                              </div>
                            </div>
                          </td>
                          <td>
                            {/* Use secureFetch's loading state here if only users fetch is in question
                                But since all data loads initially, the overallLoading handles it better */}
                            {overallLoading ? (
                              <LoadingAnimations
                                type="pulse"
                                color="#2563eb"
                                size="sm"
                              />
                            ) : (
                              <div className="d-flex gap-3 align-items-center">
                                {(() => {
                                  const seller = users.find(
                                    (u) =>
                                      u.UserEmail ===
                                      (product.UserEmail || product.sellerEmail)
                                  );
                                  return (
                                    <>
                                      <div className="order-img">
                                        {seller?.profileURL && (
                                          <img
                                            src={seller.profileURL}
                                            alt={seller.userName}
                                            style={{
                                              width: "50px",
                                              height: "50px",
                                              objectFit: "cover",
                                              borderRadius: "8px",
                                            }}
                                          />
                                        )}
                                      </div>
                                      <div>
                                        <Link
                                          to={`/profile-seller/${seller?._id}`}
                                        >
                                          <h6 className="mb-1">
                                            {seller?.userName || "N/A"}
                                          </h6>
                                        </Link>
                                        <p className="text-dark-200 mb-0">
                                          {seller?.UserEmail || "N/A"}
                                        </p>
                                      </div>
                                    </>
                                  );
                                })()}
                              </div>
                            )}
                          </td>
                          <td className="text-dark-200">
                            {
                              orders.filter(
                                (order) =>
                                  order.packageId === product._id &&
                                  order.paymentStatus === "Paid"
                              ).length
                            }
                          </td>
                          <td className="text-dark-200">
                            <p>
                              {product.viewCount > 0
                                ? `${product.viewCount} views`
                                : "No view"}
                            </p>
                          </td>
                          <td className="text-dark-200">
                            ${product.price} USD
                          </td>

                          <td className="text-center">
                            <button
                              className={`btn btn-sm ${
                                product.productStatus === "Draft"
                                  ? "btn-warning"
                                  : product.productStatus === "Published"
                                  ? "btn-info"
                                  : product.productStatus === "Approved"
                                  ? "btn-success"
                                  : "btn-secondary"
                              }`}
                              onClick={() => handleStatusChangeModal(product)}
                            >
                              {product.productStatus}
                            </button>
                          </td>
                          <td className="text-center">
                            <Link
                              to={`/admin/edit-product/${product._id}`}
                              className="btn btn-primary btn-sm"
                            >
                              <SquarePen size={15} /> Edit
                            </Link>
                          </td>
                          <td className="text-center">
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => handleDeleteClick(product)}
                            >
                              <Trash2 size={15} /> Delete
                            </button>
                          </td>
                          <DeleteConfirmationModal
                            show={showDeleteModal}
                            handleClose={() => {
                              setShowDeleteModal(false);
                              setProductToDelete(null);
                            }}
                            handleConfirm={handleDeleteProduct}
                            isDeleting={isDeleting}
                            productName={productToDelete?.productName}
                          />
                          {/*Open modal and email sent option */}
                          <td className="text-center">
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => {
                                const seller = users.find(
                                  (u) =>
                                    u.UserEmail ===
                                    (product.UserEmail || product.sellerEmail)
                                );
                                handleEmailClick(product, seller); // Make sure to pass both product and seller
                              }}
                            >
                              <Mail size={15} /> Message
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                  <AdminEmailModal
                    show={showEmailModal}
                    handleClose={() => {
                      setShowEmailModal(false);
                      setSelectedSeller(null);
                    }}
                    recipientEmail={selectedSeller?.UserEmail}
                    recipientName={selectedSeller?.userName}
                    productName={selectedProduct?.productName}
                    customProductId={selectedProduct?.productId}
                  />
                </table>
              </div>
            </div>

            <AdminProductStatusModal
              show={showStatusModal}
              handleClose={() => setShowStatusModal(false)}
              productId={selectedProduct?._id}
              customProductId={selectedProduct?.productId}
              productName={selectedProduct?.productName}
              currentStatus={selectedProduct?.productStatus}
              rejection={selectedProduct?.rejectionReason}
              onStatusUpdate={handleProductStatusUpdate}
              sellerEmail={selectedProduct?.sellerEmail}
            />
            {/* Results Summary */}
            <div className="d-flex justify-content-between align-items-center mt-4 mb-3">
              <div className="text-dark-200">
                Showing {indexOfFirstItem + 1} to{" "}
                {Math.min(indexOfLastItem, filteredProducts.length)} of{" "}
                {filteredProducts.length} products
              </div>
            </div>
            {/* Pagination */}
            {filteredProducts.length > itemsPerPage && (
              <div className="pagination-container mt-4 d-flex justify-content-center">
                <Pagination
                  currentPage={currentPage}
                  totalPages={Math.ceil(filteredProducts.length / itemsPerPage)}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default AdminAllProducts;